define('view/controller/booking/result/BookingResultPopup',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    /**
     * Booking result popup
     *
     * @class BookingResultPopup
     */
    return LayoutView.extend({

        template: '#booking_result_popup',

        modelEvents: {
            'change': 'render',
            'invalid': 'render'
        },
        regions: {
            'push_notifications': '#push-subscribe-region',
        },

        ui: {
            'inputs': ':input',
            'close' : '.close-modal',
            'close_btn_container' : '.btn-close-container',
            'close_btn' : '.btn-close-container button'
        },
        events: {
            'click @ui.close': '_onCloseModal',
            'click @ui.close_btn': '_onCloseModal'
        },

        childEvents: {
            'hide:modal': '_onCloseModal'
        },


        initialize: function () {
            var _this = this;
            LayoutView.prototype.initialize.apply(this);

            var messagesChannel = Backbone.Wreqr.radio.channel('booking_result_popup');

            messagesChannel.vent.on('addChildView', function(regionName, childView) {
                if(childView){
                    this.listenTo(childView, 'hide:close:button', function (hide){
                        if(hide){
                            _this.ui.close_btn_container.addClass('hidden');
                        } else {
                            _this.ui.close_btn_container.removeClass('hidden');
                        }
                    });
                }
                if(_this.regions[regionName]) {
                    _this.showChildView(regionName, childView);
                }
            });
        },

        serializeData: function () {
            return _.extend({
            }, LayoutView.prototype.serializeData.apply(this) || {});
        },

        hide: function (){
            this._onCloseModal();
        },

        _onCloseModal : function (){
            this.triggerMethod('close');
            if(this.getOption('region')){
                this.getOption('region').hide();
            }

        },

        onDomRefresh: function () {
            this.onShowPage();
        },

        onShowPage: function () {
            var _this = this;

            Backbone.Wreqr.radio.vent.trigger('page', 'shown', {
                'page': 'booking_result_popup',
            });
            //this.ui.close_btn_container.removeClass('hidden');
        }


    });

});
